/**
 * @generated SignedSource<<84e03253656fdb0bdd3ba0c9acc8a917>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportEventsTableRowFragment$data = {
  readonly app: {
    readonly customAppTitle: string | null;
  } | null;
  readonly datetimeRange: ReadonlyArray<string>;
  readonly name: string | null;
  readonly organizationMembershipAttendance: {
    readonly attendedAt: string;
  } | null;
  readonly organizationMembershipFeedback: {
    readonly comments: string | null;
    readonly contentRating: number;
    readonly instructorRating: number;
    readonly videoQualityRating: number;
  } | null;
  readonly organizationMembershipRSVP: {
    readonly id: string;
  } | null;
  readonly organizationMembershipRecordingVideoProgress: {
    readonly maxPercent: number;
  } | null;
  readonly product: {
    readonly name: string;
  };
  readonly recording: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrenceNameAndTimeFragment">;
  readonly " $fragmentType": "AdminMembersReportEventsTableRowFragment";
};
export type AdminMembersReportEventsTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportEventsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportEventsTableRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "organizationMembershipId",
    "variableName": "organizationMembershipId"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportEventsTableRowFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OccurrenceNameAndTimeFragment"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductApp",
      "kind": "LinkedField",
      "name": "app",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customAppTitle",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceMedia",
      "kind": "LinkedField",
      "name": "recording",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "OccurrenceRSVP",
      "kind": "LinkedField",
      "name": "organizationMembershipRSVP",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "OccurrenceAttendance",
      "kind": "LinkedField",
      "name": "organizationMembershipAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attendedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "EventFeedback",
      "kind": "LinkedField",
      "name": "organizationMembershipFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instructorRating",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoQualityRating",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentRating",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comments",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "AssetVideoProgress",
      "kind": "LinkedField",
      "name": "organizationMembershipRecordingVideoProgress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxPercent",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};
})();

(node as any).hash = "5b4f9dbccdeec5b817f31814faecfec0";

export default node;
